import { Box, Text, Link, Image, VStack, Heading, useMediaQuery, HStack, Grid } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import type { User } from '@core/app/types/contactsApiType'
import avatarDefault from '@core/assets/images/avatar_default.svg'

import PersonContactLink from '@page/post/components/AsideInfo/PersonContactLink'

// import { User } from '../../../types/types'

interface UserCardProps {
    user: User
}

export function useDesktopMediaQuery() {
    const [isDesktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })
    return isDesktop
}

const UserCard = ({ user }: UserCardProps) => {
    const { firstName, lastName, title, phone, email, image, officePhone, mobilePhone } = user
    const isDesktop = useDesktopMediaQuery()
    const { t } = useTranslation()

    return (
        <Box as="figure" overflow="hidden">
            <Image
                src={image || avatarDefault}
                alt={`${firstName} ${lastName}`}
                borderRadius="8px"
                boxSize={isDesktop ? '280px' : '166px'}
                objectFit="cover"
            />
            <VStack as="figcaption" spacing={2} align="left" mt={4} width={isDesktop ? '280px' : '166px'}>
                <Heading as="h3" color="#1A1A1A" fontWeight="600" fontSize={isDesktop ? 'xl' : 'md'}>
                    {firstName} {lastName}
                </Heading>
                {title && (
                    <Text color="#1A1A1A" fontWeight="500" fontSize="sm">
                        {title}
                    </Text>
                )}
                <VStack spacing={2} align="left" mt={2}>
                    <Grid
                        templateColumns={'auto minmax(100px, 1fr)'}
                        overflow={'hidden'}
                        gap={'12px'}
                        rowGap={'12px'}
                        alignItems={'center'}
                    >
                        <VStack alignItems={'start'} gap={'4px'} rowGap={'8px'}>
                            {officePhone?.number && (
                                <Text display={'flex'} gap={'4px'} fontSize={'sm'}>
                                    <i className="fa-solid fa-phone ContactPerson__modal__icon" />
                                    {t('2415')}:
                                </Text>
                            )}
                            {mobilePhone?.number && (
                                <Text display={'flex'} gap={'4px'} fontSize={'sm'}>
                                    <i className="fa-solid fa-mobile ContactPerson__modal__icon" />
                                    {t('2972')}:
                                </Text>
                            )}
                            {email && (
                                <Text display={'flex'} gap={'4px'} fontSize={'sm'}>
                                    <i className="fa-solid fa-envelope ContactPerson__modal__icon" />
                                    {t('92')}:
                                </Text>
                            )}
                        </VStack>
                        <VStack alignItems={'start'} gap={'4px'}>
                            {officePhone?.number && (
                                <PersonContactLink
                                    phonePrefix={officePhone.prefix}
                                    value={officePhone.number}
                                    type={'tel'}
                                />
                            )}
                            {mobilePhone?.number && (
                                <PersonContactLink
                                    phonePrefix={mobilePhone.prefix}
                                    value={mobilePhone.number}
                                    type={'tel'}
                                />
                            )}
                            {email && <PersonContactLink value={email} type={'mailto'} />}
                        </VStack>
                    </Grid>

                    {/*{phone && (*/}
                    {/*    <Text color="#404040" fontWeight="400" fontSize="sm">*/}
                    {/*        {phone}*/}
                    {/*    </Text>*/}
                    {/*)}*/}
                    {/*{email && (*/}
                    {/*    <Link*/}
                    {/*        href={`mailto:${email}`}*/}
                    {/*        fontWeight="400"*/}
                    {/*        fontSize="sm"*/}
                    {/*        textDecoration="underline"*/}
                    {/*        _hover={{ color: '#2F80ED' }}*/}
                    {/*    >*/}
                    {/*        {email}*/}
                    {/*    </Link>*/}
                    {/*)}*/}
                </VStack>
            </VStack>
        </Box>
    )
}

export default UserCard
